export default "__VITE_ASSET__DG1NUaOd__"